var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4649_12775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2287 8C18.4593 8 23.5097 13.3504 23.5097 19.9501C23.5097 26.5497 18.4589 31.8997 12.2287 31.8997C5.99848 31.8997 0.947266 26.5497 0.947266 19.9501C0.947266 13.3504 5.99811 8 12.2287 8ZM30.2442 8.7C33.3595 8.7 35.8849 13.7364 35.8849 19.9501H35.8853C35.8853 26.1623 33.3599 31.2001 30.2446 31.2001C27.1294 31.2001 24.6039 26.1623 24.6039 19.9501C24.6039 13.738 27.129 8.7 30.2442 8.7ZM38.9634 9.87179C40.0587 9.87179 40.9473 14.3839 40.9473 19.9501C40.9473 25.5147 40.0593 30.0284 38.9634 30.0284C37.8677 30.0284 36.9801 25.5159 36.9801 19.9501C36.9801 14.3843 37.8681 9.87179 38.9634 9.87179Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4649_12775"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.947266)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.d7ab41d702a8ab6c421f32a6d342f7a8.svg";
export { ForwardRef as ReactComponent };